<template>
    <field-template :title="props.inputLabel" :required="required">
        <template #content>
            <div class="input__wrapper">
                <p class="input input__text" v-if="!input">{{meaning}}</p>
                <div class="input-box" v-else>
                    <input
                        :value="meaning || ''"
                        @input="$emit('update:meaning',
                            //@ts-ignore
                            inputType == 'number' ? +$event.target.value : $event.target.value
                        )"
                        :type="inputType"
                        class="input"
                        :class="{input__error: inputError}"
                        :name="inputName"
                        :placeholder="inputContent"
                        :autocomplete="inputAutocomplete"
                        :disabled="disabled"
                        :min="min"
                        :max="max"
                    />
                    <div class="input__add-box">
                        <div class="input__clear" @click="clearValue()">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.5 11.0558L17.5558 6L19 7.44422L13.9442 12.5L19 17.5558L17.5558 19L12.5 13.9442L7.44422 19L6 17.5558L11.0558 12.5L6 7.44422L7.44422 6L12.5 11.0558Z" fill="#373840"/>
                            </svg>
                        </div>
                        <div class="input__show" v-if="showPass" @click="changeType()">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 3C17.4822 3 22.0433 6.88 23 12C22.0443 17.12 17.4822 21 12 21C6.51779 21 1.95674 17.12 1 12C1.95573 6.88 6.51779 3 12 3ZM12 19C14.0736 18.9996 16.0856 18.3068 17.7068 17.0352C19.3279 15.7635 20.4621 13.9883 20.9238 12C20.4604 10.0133 19.3255 8.24 17.7045 6.97003C16.0835 5.70005 14.0724 5.00853 12 5.00853C9.9276 5.00853 7.9165 5.70005 6.29551 6.97003C4.67452 8.24 3.53955 10.0133 3.07616 12C3.53786 13.9883 4.6721 15.7635 6.29324 17.0352C7.91439 18.3068 9.92641 18.9996 12 19ZM12 16.5C10.7866 16.5 9.62282 16.0259 8.76479 15.182C7.90675 14.3381 7.42472 13.1935 7.42472 12C7.42472 10.8065 7.90675 9.66193 8.76479 8.81802C9.62282 7.97411 10.7866 7.5 12 7.5C13.2134 7.5 14.3772 7.97411 15.2352 8.81802C16.0932 9.66193 16.5753 10.8065 16.5753 12C16.5753 13.1935 16.0932 14.3381 15.2352 15.182C14.3772 16.0259 13.2134 16.5 12 16.5ZM12 14.5C12.6741 14.5 13.3207 14.2366 13.7973 13.7678C14.274 13.2989 14.5418 12.663 14.5418 12C14.5418 11.337 14.274 10.7011 13.7973 10.2322C13.3207 9.76339 12.6741 9.5 12 9.5C11.3259 9.5 10.6793 9.76339 10.2027 10.2322C9.72597 10.7011 9.45818 11.337 9.45818 12C9.45818 12.663 9.72597 13.2989 10.2027 13.7678C10.6793 14.2366 11.3259 14.5 12 14.5Z" fill="#5C86AD"/>
                            </svg>
                        </div>
                    </div>
                    <span class="input__error-text" v-if="inputError">{{ inputError }}</span>
                </div>
                <slot name="subcontent">

                </slot>
            </div>
        </template>
    </field-template>
</template>
<script setup lang="ts">
import FieldTemplate from '../../Field/FieldTemplate.vue'

const props = defineProps({
    inputType: {
        type: String,
        required: true,
    },
    inputName: {
        type: String,
        required: true,
    },
    inputContent: {
        type: String,
        required: true,
    },
    inputLabel: {
        type: String,
    },
    inputError: {
        type: String,
    },
    inputAutocomplete: {
        type: String,
        default: "off",
    },
    meaning: {
        type: [String, Number],
    },
    required: {
        type: Boolean
    },
    disabled: {
        type: Boolean
    },
    min: {
        type: Number
    },
    max: {
        type: Number
    },
    input: {
        type: Boolean,
        default: true
    },
    clear: {
        type: Boolean,
        default: false
    },
    showPass: {
        type: Boolean,
        default: false
    }
})

function clearValue() {
    const currentInput = document.querySelector('input[name="' + props.inputName + '"]')
    //@ts-ignore
    currentInput.value = ''
}

function changeType() {
    const currentInput = document.querySelector('input[name="' + props.inputName + '"]')
    //@ts-ignore
    currentInput.type === 'password' ? currentInput.type = 'text' : currentInput.type = 'password'
}
</script>
